export default "__VITE_ASSET__DxBGsz2___"